import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { AlertProvider } from "./contexts/AlertContext"; // Import AlertProvider
import Login from "./pages/Login_v2"; // Import updated Login component
import { publicRoutes, protectedRoutes, permissionRoutes } from "./routes"; // Import routes
import MainLayout from "./components/MainLayout"; // Assuming you have a layout for protected routes
import { AuthProvider } from "./contexts/AuthContext"; // Assuming you have AuthProvider for authentication
import { LoadingProvider } from "./contexts/LoadingContext"; // Assuming you have LoadingProvider
import AlertMessage from "./components/AlertMessage"; // Assuming you have an AlertMessage component for displaying alerts

import MissingCorpPrefixAlert from "./components/MissingCorpPrefixAlert";

// Contexts and Providers
// import { AuthProvider } from "./contexts/AuthContext";
// import { AlertProvider } from "./contexts/AlertContext";
// import { LoadingProvider } from "./contexts/LoadingContext";
// import { WebSocketProvider } from "./contexts/WebSocketContext";
// import { MemberWebSocketProvider } from "./contexts/MemberWebSocketContext";
import { AdminAccessAlertProvider } from "./contexts/AdminAccessAlertContext";
import { RateLimitAlertProvider } from "./contexts/RateLimitAlertContext";

import { MissingCorpPrefixAlertProvider } from "./contexts/MissingCorpPrefixAlertContext";
import { MissingNetworkAccessFeeAlertProvider } from "./contexts/MissingNetworkAccessFeeAlertContext";
import { MissingActualCorpNameAlertProvider } from "./contexts/MissingActualCorpNameAlertContext";

const App = () => {
  return (
    <Router>
      <GoogleOAuthProvider clientId="250558744471-r449ll7v9fhqumea0utvtj0jae3n6odm.apps.googleusercontent.com">
        <AlertProvider>
          <AuthProvider>
            <LoadingProvider>
              <RateLimitAlertProvider>
                <AdminAccessAlertProvider>
                  <MissingCorpPrefixAlertProvider>
                    <MissingNetworkAccessFeeAlertProvider>
                    <MissingActualCorpNameAlertProvider>
                      <AlertMessage />
                      <Routes>
                        {/* Public Route with reCAPTCHA */}
                        {publicRoutes}

                        {/* Protected and Permission Routes */}
                        <Route path="/" element={<MainLayout />}>
                          {protectedRoutes.map((route) => (
                            <Route
                              key={route.path}
                              path={route.path}
                              element={route.element}
                            />
                          ))}
                          {permissionRoutes.map((route) => (
                            <Route
                              key={route.path}
                              path={route.path}
                              element={route.element}
                            />
                          ))}
                        </Route>
                      </Routes>
                      </MissingActualCorpNameAlertProvider>
                    </MissingNetworkAccessFeeAlertProvider>
                  </MissingCorpPrefixAlertProvider>
                </AdminAccessAlertProvider>
              </RateLimitAlertProvider>
            </LoadingProvider>
          </AuthProvider>
        </AlertProvider>
      </GoogleOAuthProvider>
    </Router>
  );
};

export default App;
